import React from "react";
import { formatShortScheduleListDate } from "../../../helpers/dateFormatter";

const BDTerms = ({ bookingDetails }) => {
  return (
    <div className="bd-p-terms mt-lg-0 mt-3  p-3 ">
      <p className="bd-p-pax-info-title m-0 pb-2">Terms & Conditions</p>
      <ul className="bd-p-header-date">
        <li>
          Valid till {formatShortScheduleListDate(bookingDetails?.trip_date)}
        </li>
        <li>Voucher cannot be exchanged for cash.</li>
      </ul>
    </div>
  );
};

export default BDTerms;
